import { Empty } from 'antd';

const NoImage = () => <Empty description={'No photos'} />;

export default NoImage;
